import { useQuery } from 'react-query';
import { ace_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { callsKeys } from '../../cache-keys/callsKeys';
import { ace } from '@axo/shared/data-access/types';
import { queryFunction } from '../../query-function';

export function useCallRecords(req: ace.FindCallRecordsRequest) {
  const api = useAPI();
  const cacheKey = callsKeys.records(req);

  return useQuery({
    queryKey: [cacheKey],
    queryFn: queryFunction(
      ace_api.getCallRecords(api),
      ({ queryKey: [{ LoanApplicationID, CustomerPhoneNumber }] }) => ({
        LoanApplicationID,
        CustomerPhoneNumber,
      }),
    ),
    enabled:
      api.token.length > 0 &&
      req.LoanApplicationID !== '' &&
      req.CustomerPhoneNumber !== '',
  });
}
